export function getMinPasswordLength(): number {
  return 8;
}

export function getRowsPerPage(): number {
  return 25;
}

export function getDebounceInterval(): number {
  return 500;
}

export function getBaseURL(): string {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  console.log(`API Base URL: ${apiUrl}`);
  if (apiUrl !== undefined) {
    return apiUrl;
  }
  return "https://bandobast.gaggle.online/api/v1";
  // return "http://localhost:5000/api/v1";
}

export function getDefaultLocation() {
  // Bangalore
  // return { lat: 12.997, lng: 77.6144 };
  // Ahmedabad
  return { lat: 23.0225, lng: 72.5714 };
}

export function getDefaultZoom() {
  return 15;
}

export function getGoogleMapsKey() {
  return "AIzaSyCIJ6x_WFi3UMf9HnNVon5afLQqj1Izxmw";
}
